export default __webpack_public_path__ + "static/media/archana.325adb78.png";